/* global Modal */

if (!customElements.get('klaviyo-popup')) {
    class KlaviyoPopUp extends HTMLElement {
        constructor() {
          super();
          this.fetch = null;
          this.fetchedUrls = [];
          this.documentClickHandler = this.handleDocumentClick.bind(this);
          this.keydownHandler = this.handleKeydown.bind(this);
          this.opener = null;
          this.closeBtn = this.querySelector('.bis-close');
          this.productTitle = this.querySelector('.js-bis-title');
          this.variantTitle = this.querySelector('.js-bis-variant-title');
          this.variantId = this.querySelector('input[name="variant"]');
          this.form = this.querySelector('.klaviyo-bis-form');
          this.submitBtn = this.querySelector('#bis-submit');
          this.chcekBox = this.querySelector('#bis-confirm');
          this.emailInput = this.querySelector('#bis-email');
          this.successAlert = this.querySelector('.bis-success');
          this.errorAlert = this.querySelector('.bis-error');

          document.addEventListener('click', this.documentClickHandler);
          this.addEventListener('click', this.handleCloseClick);
          // The form is submitted with a real submit button (disabled until the box is ticked), so the browser applies
          // required / type=email first and Enter in the email field no longer reloads the page.
          this.form.addEventListener('submit', this.handleSubmit.bind(this));
          this.chcekBox.addEventListener('change', this.handleCheckBox.bind(this));
        }

        disconnectedCallback(){
            document.removeEventListener('click', this.documentClickHandler);
            document.removeEventListener('keydown', this.keydownHandler);
        }

        handleDocumentClick(evt){
            const opener = evt.target.closest('.back-in-stock-button');
            if (!opener) return;
            this.opener = opener;
            this.style.display = "block";
            this.removeAttribute('aria-hidden');
            this.productTitle.textContent = opener.dataset.product;
            this.variantTitle.textContent = opener.dataset.variant;
            this.variantId.value = opener.dataset.vid;
            document.addEventListener('keydown', this.keydownHandler);
            if (this.closeBtn) this.closeBtn.focus();
        }

        closePopup(){
            this.style.display = "none";
            this.setAttribute('aria-hidden', 'true');
            document.removeEventListener('keydown', this.keydownHandler);
            if (this.opener && this.opener.focus) this.opener.focus();
        }

        handleCloseClick(evt){
           if(!evt.target.closest('.bis-close')) return;
           this.closePopup();
        }

        handleKeydown(evt){
          if (evt.key === 'Escape') {
            evt.preventDefault();
            // W2-T3: this Escape keydown closes the pop-up; its keyup must not also reach the quick-add drawer behind it
            // (the drawer closes on Escape keyup). One-shot, capture phase on document, so nothing below it sees that keyup.
            document.addEventListener('keyup', (e) => { if (e.key === 'Escape') e.stopPropagation(); }, { capture: true, once: true });
            this.closePopup();
            return;
          }
          if (evt.key !== 'Tab') return;
          // Keep Tab and Shift+Tab inside the dialog.
          const items = Array.from(this.querySelectorAll('button, a[href], input, select, textarea, [tabindex]'))
            .filter((el) => !el.disabled && el.tabIndex >= 0 && el.getClientRects().length > 0);
          if (!items.length) { evt.preventDefault(); return; }
          const first = items[0];
          const last = items[items.length - 1];
          const active = document.activeElement;
          if (evt.shiftKey && (active === first || !this.contains(active) || active === this)) {
            evt.preventDefault();
            last.focus();
          } else if (!evt.shiftKey && (active === last || !this.contains(active))) {
            evt.preventDefault();
            first.focus();
          }
        }
        handleCheckBox(evt){
          if(!evt.target.matches('#bis-confirm')) return;

          if(this.chcekBox.checked){
            this.submitBtn.disabled = false;
          }else{
            this.submitBtn.disabled = true;
          }
        }

        handleSubmit(evt){
          evt.preventDefault();
          if (!this.chcekBox.checked) return;

          const payload = JSON.stringify({
            data: {
              type: "back-in-stock-subscription",
              attributes: {
                profile: {
                  data: {
                      type: "profile",
                      attributes: {
                          email: `${this.emailInput.value}`,
                      }
                  }
                },
                channels: ["EMAIL"],
              },
              relationships: {
                variant: {
                  data: {
                    type: "catalog-variant",
                    id: `$shopify:::$default:::${this.variantId.value}`
                  }
                }
              }
            }
          });



          let requestOptions = {
            method: 'POST',
            headers: {"Content-Type": "application/json", "revision": "2023-10-15", "Authorization": "pk_64959439ad9b43cc0b7352da49ea800157", 'Access-Control-Allow-Origin':'*'},
            mode: 'cors',
            body: payload
          }

          let companyId = "iUWEFA";
          const store = Shopify.shop.split(".myshopify")[0];
          if(store === "umbra-ca"){
            companyId = "KiLPmu"
          }else if(store === "umbra-eu"){
            companyId = "Pu3mAK"
          }else if(store === "umbra-uk"){
            companyId = "JiqHEq"
          }else{

          }

          fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${companyId}`, requestOptions)
            .then((response) => {
                 // Only a 2xx answer from Klaviyo is a subscription; anything else is an error.
                 if (!response.ok) throw new Error(response.status);
                 if(this.successAlert){
                  setTimeout(() => {
                    this.successAlert.hidden = false
                  }, 1000)

                  setTimeout(() => {
                    this.successAlert.hidden = true
                  }, this.successAlert.dataset.visibleFor)
                 }
            })
            .catch(() => {
              if(this.errorAlert){
                this.errorAlert.hidden = false
                setTimeout(() => {
                  this.errorAlert.hidden = true
                }, this.errorAlert.dataset.visibleFor)
              }
            });

        }
      }

      customElements.define('klaviyo-popup', KlaviyoPopUp);
  }
